export * from './ApiClient';
// API helpers for different use cases
export * from './pinia';
export * from './vueQuery';
import { apiClient } from './ApiClient';

// Base URL used by the API client
export { API_BASE_URL as baseUrl } from './ApiClient';

// Backward compatible API client instance
export const provider = apiClient;
